import { BpStatusStyle } from '../../../../../../../constants';
import { IChartDotProps } from './types';

export const ChartDot = ({ type, cx = 0, cy = 0, payload }: IChartDotProps) => {
  if (!payload.dia || !payload.sys) {
    return <></>;
  }

  const size = 14;
  const x = cx - size / 2;
  const y = cy - size / 2;
  const props = {
    key: payload._id,
    stroke: payload.bpType ? BpStatusStyle[payload.bpType]?.color : BpStatusStyle.PENDING.color,
    strokeWidth: 4,
    fill: '#fff',
  };

  return type === 'sys' ? (
    <circle {...props} cx={cx} cy={cy} r={8} />
  ) : (
    <rect
      {...props}
      x={x}
      y={y}
      width={size}
      height={size}
      className="origin-center rotate-45"
      style={{ transformBox: 'fill-box' }}
    />
  );
};
